export const translations = {
    UA: {

        mql5: {
            title: "Ми офіційно на маркетплейсі MQL5",
            description: "Тепер наші торгові алгоритми доступні на найбільшому незалежному майданчику для трейдерів.<br/><br/>Ми за абсолютну прозорість результатів. Перевіряйте реальну статистику, історію угод та підключайте ботів у безпечному середовищі.",
        },
        menu: {
            how: "Як працюють",
            advantages: "Переваги",
            catalog: "Каталог ботів",
            reviews: "Відгуки",
            faq: "FAQ",
        },
        buttons: {
            selectBot: "Обрати бота",
            openMql: "Відкрити в MQL5",
        },
        terra: {
            seo: {
                title: "Terra EA — Торговий бот з найдовшою статистикою в Україні",
                description: "Terra EA: понад 2 роки підтвердженої статистики, 23 з 24 місяців у плюс. Надійний алгоритм для MT4/MT5 з річним прибутком +20% та контролем ризику.",
                keywords: "Terra EA, торговий робот статистика, форекс бот скачати, автоматична торгівля MT4, алгоритм RSI Bollinger, стабільний заробіток на трейдингу"
            },

            hero: {
                theme: "Бот з найдовшою статистикою в Україні",
                desc: "Має понад 2 роки підтвердженої статистики зі стабільними результатами",
                buy: "Придбати бота",
                slogan: "Основа вашого капіталу",
                about: "Як земля, <span>що підтримує все живе і слугує фундаментом для всього,</span> Terra EA забезпечить вам надійну основу <span>для торгівлі зі стабільними результатами.</span><br/><br/>Алгоритм створено для тих, <span>хто шукає впевненість.</span><br/><br/>Стратегія має <span>прибуткове математичне очікування</span> і пройшла перевірку часом і ринком.",

                videoFallback: "Ваш браузер не підтримує відео."
            },

            advantages: {
                titleAccent: "Інтелектуальний підхід",
                title: "до трейдингу",
                items: [
                    {
                        title: "Комбінація індикаторів",
                        desc: "В основі алгоритму лежить синергія RSI, Bollinger Bands та ATR."
                    },
                    {
                        title: "Розумний ризик-менеджмент",
                        desc: "Грамотне управління капіталом, хеджування позицій та використання мартингейла лише за необхідності."
                    },
                    {
                        title: "Money менеджмент",
                        desc: "Терра демонструє ефективну роботу з мінімальними просадками при депозиті від 1000$, що для мартінгейл ботів є рідкістю."
                    }
                ]
            },
            results: {
                title: "Результати говорять самі за себе",
                subtitle: "23 з 24 місяців торгівлі закриті в плюс.",
                stats: [
                    {label: "Year profit", value: "+25%"},
                    {label: "Max drawdown", value: "16.5%"},
                    {label: "Winrate", value: "72.3%"}
                ],
                button: "Дивитися статистику"
            },

            video: {
                titleAccent: "Відео-демонстрація",
                title: "роботи бота"
            },

            reviews: {
                titleAccent: "Що кажуть ті,",
                title: "хто користуються TERRA EA"
            },
            reviews1: {
                more: "Більше відгуків"
            },

            tests: {
                title: "Результати тестів",
                titleAccent: "за останні 10 років",

                period: "Період тестування",
                timeframe: "Таймфрейм",
                timeframeValue: "1 година (H1)",
                dates: "Дати тестування",

                depositProfit: "Депозит та прибуток",
                startDeposit: "Початковий депозит",
                netProfit: "Чистий прибуток",

                pairs: "Валютні пари",

                risk: "Ризик",
                maxDrawdown: "Максимальна просадка",

                trades: "Статистика угод"
            },

            buy: {
                desc: "Надійний фундамент для автоматичної торгівлі зі стабільними результатами.",
                price: "Ціна",
                buy: "Придбати",
                parts: "Оплата частинами"
            },

            stats: {
                yearProfit: "Year profit",
                maxDrawdown: "Max drawdown",
                winrate: "Winrate"
            },

            footer: {
                instagram: "Instagram",
                telegram: "Telegram",
                youtube: "Youtube"
            }, reviewsList: [
                {
                    name: "Taras O.",
                    text: "Користуюсь ботом з листопада і дуже задоволений результатом. Шукав інструмент для пасивного доходу з низькими ризиками — цей варіант підійшов ідеально. За два місяці отримав 4% чистого прибутку завдяки системі складного відсотка. Бот повністю автоматичний: налаштував за допомогою продавця і більше не втручався. Особливо радує, що система сама вимикається під час сильних новин, мінімізуючи ризики. Очікую близько 40% річних. Рекомендую як надійний та безпечний інструмент.",
                },
                {
                    name: "Max S.",
                    text: "Бот демонструє відмінну роботу. Використовую його на мінімальних ризиках для стабільного приросту капіталу. Для мене це стала чудова альтернатива іншим способам диверсифікації коштів під відсоток. Величезним плюсом є те, що бот інтегрується з біржею Bybit, і я можу тримати весь депозит на власному рахунку, що додає впевненості у безпеці активів. Інструмент зручний, зрозумілий і, головне, приносить прогнозований прибуток без зайвого клопоту та щоденного моніторингу.",
                },
                {
                    name: "Dmytro P.",
                    text: "Користуюсь ботом «Терра» вже три місяці. Вирішив протестувати стратегію на високих ризиках і результат вразив — маю +48% до депозиту. Дуже круто, що розробник постійно оновлює налаштування та завжди на зв’язку в чаті, відповідаючи на всі питання. Окрім технічної частини, імпонує чесність автора: слова в постах завжди відповідають реальним цифрам. Це викликає велику довіру. З нетерпінням чекаю на нові релізи та алгоритми, бо цей продукт однозначно вартий уваги.",
                },
                {
                    name: "Valerii R.",
                    text: "Придбав цей софт близько місяця тому і вже можу зробити перші висновки. Процес налаштування пройшов швидко, алгоритм стратегії зрозумілий навіть без глибоких технічних знань. Бот працює дуже чітко, без технічних збоїв чи помилок у виконанні ордерів. Це саме той продукт, який відповідає заявленим характеристикам. Поки що все йде за планом, результати стабільні, тож можу сміливо радити цього бота тим, хто цінує якість виконання та зрозумілу логіку торгівлі.",
                },
                {
                    name: "Sergii I.",
                    text: "Працюю з ботом «Терра» вже п’ятий місяць. Свідомо пішов на експеримент і занизив рівень безпеки (завищив ризики), хоча розробник попереджав про можливі наслідки. Незважаючи на це, результатом за цей період дуже задоволений — бот витримав ринкові рухи та показав гарний плюс. Система працює стабільно навіть при агресивних налаштуваннях. Дякую Вові за якісний продукт, який дає можливість гнучко керувати своєю стратегією та отримувати бажаний прибуток на дистанції.",
                },
            ],
            botInfoPopup: {
                botInfo: [
                    "Безлімітна кількість активацій бота",
                    "Пожиттєвий доступ до оновлень",
                    "2 версії під MT4/MT5",
                    "Відеоінструкції з налаштуванням на кожному етапі",
                    "Сет файли під різні види ризику",
                    "Доступ до закритого каналу з новинами",
                    "Гарантія 100% ідентичності ваших результатів з нашими"
                ],
                botName: "TERRA EA",
                botPrice: 1000
            }, calculator: {
                titleAccent: "Розрахуйте свою",
                title: "довгострокову дохідність",
                themes: {
                    sumAndTerm: "Сума та термін",
                    interest: "Нарахування відсотків",
                    refill: "Поповнення"
                },
                labels: {
                    startSum: "Початкова сума",
                    unit: "Одиниця виміру",
                    term: "Термін",
                    frequency: "Періодичність",
                    rate: "Відсоткова ставка",
                    sum: "Сума"
                },
                units: {
                    year: "Рік",
                    month: "Місяць",
                    yearly: "Щорічно",
                    monthly: "Щомісяця"
                },
                warnings: {
                    startSum: "Сума, з якої починаються інвестиції",
                    term: "Кількість років/місяців, протягом яких ви плануєте інвестувати кошти",
                    rate: "Розмір річного/місячного доходу у відсотках",
                    refill: "Сума, на яку плануєте поповнювати"
                },
                button: "Розрахувати дохідність",
                table: {
                    tableName: "Таблиця з розрахунками",
                    balance: "Баланс",
                    addedYear: "Поповнено (рік)",
                    addedMonth: "Поповнено (міс.)",
                    totalAdded: "Сумарні інвестиції",
                    incomeYear: "Річний дохід",
                    incomeMonth: "Місячний дохід",
                    totalIncome: "Загальний дохід",
                    finalBalance: "Підсумковий баланс",
                    description: "Terra EA в середньому робить стабільні +25% на рік/2.1% на місяць.<br/>Чим більший термін інвестицій, тим більша магія складного відсотку!",
                    descriptionAero: "Aero EA в середньому робить стабільні +30% на рік/2.5% на місяць.<br/>Чим більший термін інвестицій, тим більша магія складного відсотку!",
                    descriptionHydro: "Hydro EA в середньому робить стабільні +50% на рік/4.2% на місяць.<br/>Чим більший термін інвестицій, тим більша магія складного відсотку!"
                }
            }


        },
        aero: {
            reviewsList: [
                {
                    name: "Dmytro P.",
                    text: "Пишу відгук за результатами першого тижня торгів. Приємно, що всі угоди чітко сходяться з моніторингом на Myfxbook, профіт йде абсолютно закономірний. Початок чудовий, тож сподіваюсь на довгу та плідну співпрацю.",
                },
                {
                    name: "Mykola F.",
                    text: "За перший місяць користування ботом отримав такий результат ⬆️ +5% чистого прибутку до депозиту. Працює стабільно, без зайвого ризику, з чіткою логікою входів і виходів. Для мене це хороший та прогнозований результат.",
                },
                {
                    name: "Sergii H.",
                    text: "Привіт! Користуюся ботом Aero вже рівно два місяці. За цей час на моєму власному депозиті на біржі Bybit він наторгував +321$. Результатом повністю задоволений, бот показує себе чудово на дистанції.",
                },
                {
                    name: "Alex D.",
                    text: "Пишу відгук про свій досвід використання ботів. Придбав одразу два алго — дуже сподобалась подача та презентація. Запустив на одному рахунку й отримав хороші цифри. Підтримка, консультації та супровід — на високому рівні.",
                },
                {
                    name: "Dmytro S.",
                    text: "Всім привіт. Минуло два місяці з моменту покупки бота Aero. На особистому рахунку Bybit чистий прибуток склав вже +321$. Система працює стабільно і повністю виправдовує вкладені кошти.",
                },
            ],
            botInfoPopup: {
                botInfo: [
                    "Безлімітна кількість активацій бота",
                    "Пожиттєвий доступ до оновлень",
                    "2 версії під MT4/MT5",
                    "Відеоінструкції з налаштуванням на кожному етапі",
                    "Сет файли під різні види ризику",
                    "Доступ до закритого каналу з новинами",
                    "Гарантія 100% ідентичності ваших результатів з нашими",
                    "Налаштування бота під проп-компанію"
                ],
                botName: "AERO EA",
                botPrice: 1200
            }, hero: {
                botName: "Aero EA",
                theme: "Торговий бот з найнижчими просадками",
                desc: "Має понад 11 місяців підтвердженої статистики і 10 років тестів зі стабільними результатами.",
                buy: "Придбати бота",
                slogan: "Безпека вашого капіталу",
                about: "Aero — елемент повітря; він може бути як спокійним, <span>немов легкий бриз, так і динамічним, як шторм,</span> перетворюючи вітер на шквал завдяки налаштовуваним рівням ризику.<br/><br/>В його основі лежить алгоритм розпізнавання патернів — kNN (k-найближчих сусідів), <span>метод машинного навчання, навчений на даних про ціну золота за 25+ років.</span><br/><br/>Результат: <span>короткі, чисті угоди з незмінно високим вінрейтом і чітко визначеним ризиком у кожній позиції.</span>",
                videoFallback: "Ваш браузер не підтримує відео."
            },
            seo: {
                title: "Aero EA — Безпечний торговий бот з просадкою 3.7%",
                description: "Aero EA: алгоритм на базі AI для XAUUSD (Gold). Без мартингейла та сіток. Ідеально підходить для проп-компаній. Winrate 86.8% та стабільний прибуток.",
                keywords: "Aero EA, бот для проп компаній, безпечний трейдинг бот, робот для золота XAUUSD, трейдинг без мартингейла, торгові боти AI"
            },
            advantages: {
                title: "Переваги",
                items: [
                    {
                        title: "Підходить для проп-компаній",
                        desc: "Оскільки він не використовує заборонених стратегій, Aero підходить для більшості популярних проп-компаній."
                    },
                    {
                        title: "Адаптація до ринку",
                        desc: "Алгоритм працює на пробій ключових цінових рівнів і підлаштовується під різні стадії ринку."
                    },
                    {
                        title: "Гнучкість під будь-який стиль торгівлі",
                        desc: "Ідеальний як для консервативних, так і для агресивних трейдерів. Ви самі контролюєте стиль торгівлі."
                    },
                    {
                        title: "Повна автоматизація",
                        desc: "Aero EA працює у фоновому режимі, повністю автоматизований і не потребує постійної участі."
                    }
                ]
            }, results: {
                subtitle: "На live рахунку Aero демонструє феноменальний результат з дохідністю 2%/місяць при просадці 3.7%",
                winrateText: "При цьому його winrate досягнув показника в 86.8%.",
                stats: [
                    {label: "Year profit", value: "+30%"},
                    {label: "Max drawdown", value: "3.7%"},
                    {label: "Winrate", value: "86.8%"}
                ],
                button: "Дивитися статистику"
            },
            video: {
                title: "<span>Відео-демонстрація</span><br/> роботи бота"
            },
            propInfo: {
                title: "Дізнайтесь як збільшити дохідність Aero за допомогою проп-компаній",
                button: "Читати більше"
            }, reviews: {
                titleAccent: "Що кажуть ті,",
                title: "хто користуються AERO EA"
            },
            tests: {
                winTrades: "Прибуткові угоди"
            }, buy: {
                desc: "Надійний фундамент для автоматичної торгівлі зі стабільними результатами.",
            }
        }, hydro: {
            reviewsList: [
                {
                    name: "Valerii R.",
                    text: "Придбав бота два тижні тому, зацікавила детальна статистика 📈 Тестував його тиждень, бо в цій сфері давно і знаю, що часто на словах одне, а на практиці зовсім інше. Можу підтвердити — все відповідає заявленому, трейди сходяться зі статистикою.",
                },
                {
                    name: "Eduard F.",
                    text: "Бот успішно пройшов першу фазу на FTMO за 22 торгові дні ✅ Другу фазу верифікації закрив усього за 4 дні. Результатом повністю задоволений, працює стабільно, без сюрпризів, дотримується ризик-менеджменту та показує прогнозований результат.",
                },
                {
                    name: "Dmytro K.",
                    text: "Зробив свій перший вивід коштів з трейдингу за довгий період часу. Чесно — дуже приємні відчуття, особливо коли результат отриманий без постійного контролю. Чудовий бонус і подарунок до майбутніх свят, який реально мотивує рухатися далі.",
                },
                {
                    name: "Dmytro A.",
                    text: "Маю результат в +1200$ на власному рахунку Bybit! Бот торгує 3 місяці, планую збільшувати депозит найближчим часом",
                },
                {
                    name: "Nikolay S.",
                    text: "Привіт ще раз, хочу написати відгук про роботу бота і, власне, про твою роботу. Спочатку бот купувався під проп, відразу скажу, що був попереджений, що всі ризики з пропами беру на себе. Що стосується особистого депозиту, бот з усіма злетами і падіннями приніс 4-5% за період з 18 серпня.",
                },
                {
                    name: "Volodymyr D.",
                    text: "У мене вийшло за місяць з урахуванням стопа на Лоу ризик і хай ризик по 20%😂",
                },
            ],
            botInfoPopup: {
                botInfo: [
                    "Безлімітна кількість активацій бота",
                    "Пожиттєвий доступ до оновлень",
                    "2 версії під MT4/MT5",
                    "Відеоінструкції з налаштуванням на кожному етапі",
                    "Сет файли під різні види ризику",
                    "Доступ до закритого каналу з новинами",
                    "Гарантія 100% ідентичності ваших результатів з нашими",
                    "Налаштування бота під проп-компанію"
                ],
                botName: "HYDRO EA",
                botPrice: 2000
            }, hero: {
                botName: "Hydro EA",
                theme: "Торговий бот з найвищою дохідністю",
                desc: "Має понад 7 місяців підтвердженої статистики і 10 років тестів зі стабільними результатами.",
                buy: "Придбати бота",
                slogan: "Приріст вашого капіталу",
                about: "Hydro поєднує спокій глибоких вод і силу припливів, <span>допомагаючи знаходити баланс між стабільністю та прибутковістю.</span><br/><br/>Він швидко реагує на зміни ринку, <span>знаходячи оптимальні точки входу</span> та виходу з високою точністю.<br/><br/>Маючи Winrate вище 90% та дохідність більше 4.5% на місяць, <span>Hydro показує себе як довершений скальпінг бот, який максимально імітує людську торгову поведінку.</span>",
                videoFallback: "Ваш браузер не підтримує відео."
            },
            seo: {
                title: "Hydro EA — Торговий бот з Winrate 91.9% та високою прибутковістю",
                description: "Hydro EA: професійний скальпінг-бот для Gold (XAUUSD). Середня дохідність 5% на місяць, захист від волатильності та робота без мартингейла. Найкращий вибір для капіталу.",
                keywords: "Hydro EA, скальпінг бот, високоприбутковий торговий робот, бот для золота, Winrate 90 трейдинг, автоматизація XAUUSD, професійні торгові алгоритми"
            },
            advantages: {
                title: "Переваги",
                items: [
                    {
                        title: "Інтелектуальна точність",
                        desc: "Високий win rate завдяки інтелектуальному аналізу"
                    },
                    {
                        title: "Контроль ризиків",
                        desc: "Торгує зі стоп-лоссами без мартингейла та усереднень"
                    },
                    {
                        title: "Захист від волатильності",
                        desc: "Має фільтр новин для уникнення торгівлі у волатильний час"
                    },
                    {
                        title: "Проп-сумісність",
                        desc: "Завдяки відсутності мартингейла та сітки, алгоритм повністю відповідає жорстким правилам ризик-менеджменту більшості проп-компаній."
                    },
                    {
                        title: "Цілодобовий моніторинг",
                        desc: "Алгоритм працює 24/7 без емоцій та втоми, миттєво реагуючи на торгові сигнали в будь-яку сесію."
                    }
                ]
            }, results: {
                subtitle: "На публічному рахунку Hydro демонструє феноменальний результат із середньою дохідністю в 5% місячних.",
                winrateText: "При цьому його winrate досягнув показника в 91.9%.",
                stats: [
                    {label: "Year profit", value: "+50%"},
                    {label: "Max drawdown", value: "14.3%"},
                    {label: "Winrate", value: "91.9%"}
                ]
            },
            propInfo: {
                title: "Дізнайтесь як збільшити дохідність Hydro за допомогою проп-компаній"
            }, reviews: {
                titleAccent: "Що кажуть ті,",
                title: "хто користуються HYDRO EA"
            },
            tests: {
                timeframeValue: "1 день ( D1 )"
            }
        }, home: {
            bestOfferProp:"Найкращий вибір для проп-компаній",
            piecePay: "Доступна оплата частинами",
            trailer:"Трейлер",
            mainVideoText:"Що ми створюємо",
            mainVideoDesc:"Наш офіційний тизер — філософія, елементи та стандарти, що лежать в основі кожної системи, яку ми випускаємо.",
            mainVideoButton:"Дізнайтеся більше про Algo",
            botsList: [
                {
                    name: "Terra EA",
                    description: "Бот з найдовшою публічною статистикою в Україні.",
                    advantages: {yearProfit: "+25%", maxDrawDown: "16.5%", winRate: "72.3%"},
                    price: 1000,
                    href: "/terra",
                    prop: false,
                    paying: true,
                },
                {
                    name: "Aero EA",
                    description: "Бот з найнижчою просадкою в асортименті.",
                    advantages: {yearProfit: "+30%", maxDrawDown: "3.7%", winRate: "86.8%"},
                    price: 1200,
                    href: "/aero",
                    prop: true,
                    paying: true,
                },
                {
                    name: "Hydro EA",
                    description: "Бот з найвищою прибутковістю в асортименті.",
                    advantages: {yearProfit: "+50%", maxDrawDown: "14.3%", winRate: "91.9%"},
                    price: 2000,
                    href: "/hydro",
                    prop: true,
                    paying: true
                }
            ],
            reviewsList: [
                {
                    name: "Valerii R.",
                    text: "Придбав бота два тижні тому, зацікавила детальна статистика 📈 Тестував його тиждень, бо в цій сфері давно і знаю, що часто на словах одне, а на практиці зовсім інше. Можу підтвердити — все відповідає заявленому, трейди сходяться зі статистикою."
                },
                {
                    name: "Eduard F.",
                    text: "Бот успішно пройшов першу фазу на FTMO за 22 торгові дні ✅ Другу фазу верифікації закрив усього за 4 дні. Результатом повністю задоволений, працює стабільно, без сюрпризів, дотримується ризик-менеджменту та показує прогнозований результат."
                },
                {
                    name: "Dmytro K.",
                    text: "Зробив свій перший вивід коштів з трейдингу за довгий період часу. Чесно — дуже приємні відчуття, особливо коли результат отриманий без постійного контролю. Чудовий бонус і подарунок до майбутніх свят, який реально мотивує рухатися далі."
                },
                {
                    name: "Andry D.",
                    text: "Пишу відгук про свій досвід використання ботів. Придбав одразу два алго — дуже сподобалась подача та презентація. Запустив на одному рахунку й отримав хороші цифри. Підтримка, консультації та супровід — на високому рівні."
                },
                {
                    name: "Mykola P.",
                    text: "За перший місяць користування ботом отримав такий результат ⬆️ +5% чистого прибутку до депозиту. Працює стабільно, без зайвого ризику, з чіткою логікою входів і виходів. Для мене це хороший та прогнозований результат."
                },
                {
                    name: "Max S.",
                    text: "Довго не доходили руки залишити фідбек по Террі. За 3 місяці на підвищеному ризику отримав +48%. Дуже задоволений ботом, постійними оновленнями налаштувань і підтримкою. Окрема повага за чесність — усе, що пишеш, відповідає реальності."
                }
            ], hero: {
                title: "Ваш капітал зростає — без вашої участі",
                desc: "Торгові боти які самостійно працюють за чіткою стратегією — з мінімальною просадкою та реальною історією на живих рахунках.",
                button: "Обрати бота"
            }, stats: {
                title: "<span>Наша команда вже автоматизувала трейдинг</span><br/>для багатьох клієнтів, допоможемо і вам",
                management: "в управлінні",
                items: [
                    {num: "2", desc: "Роки на ринку"},
                    {num: "4", desc: "Профітних ботів"},
                    {num: "5", desc: "Рахунків з live статистикою"},
                    {num: "+80%", desc: "За 2025 рік"}
                ]
            }, faq: [
                {
                    question: "Як підібрати бота?",
                    answer: "Усі ризики щодо кожного бота прописані на його сторінці. Ми працюємо виключно зі стабільними налаштуваннями ризику, які не перевищують 15-20% просідання від депозиту."
                },
                {
                    question: "Чи потрібно постійно тримати комп'ютер увімкненим?",
                    answer: "Ні. Боти працюють на віддалених серверах. Ви можете вимкнути телефон або ноутбук — процес не перерветься."
                },
                {
                    question: "Чи потрібен великий досвід у трейдингу?",
                    answer: "Абсолютно ні, все що потрібно — це створити акаунт і підключити бота. Відеоінструкції будуть доступні одразу після покупки."
                },
                {
                    question: "Чи можна втратити весь депозит?",
                    answer: "Наші боти протестовані на різних етапах ринку та в критичних ситуаціях. З нашими налаштуваннями злив депозиту неможливий."
                },
                {
                    question: "Як отримати консультацію?",
                    answer: "Для правильного підбору рекомендуємо ознайомитися з кожним ботом або звернутися за консультацією в телеграм, де ми визначимо підходящий вам алгоритм."
                }
            ],
            steps: {
                title: "<span>Шлях від налаштування</span> до першої угоди",
                items: [
                    {
                        title: "Вибір алгоритму",
                        desc: "Ви визначаєте свої цілі та допустимий ризик. У нашому каталозі є рішення як для консервативного накопичення, так і для активної торгівлі."
                    },
                    {
                        title: "Підключення",
                        desc: "Бот встановлюється на ваш акаунт за кілька кліків. Ви отримуєте всі інструкції та ліцензію для активації."
                    },
                    {
                        title: "Автономна торгівля",
                        desc: "Алгоритм сканує ринок 24/7. Як тільки умови стратегії збігаються, бот миттєво відкриває позицію."
                    },
                    {
                        title: "Моніторинг і результат",
                        desc: "Ви слідкуєте за статистикою в реальному часі. У будь-який момент роботу бота можна призупинити або змінити."
                    },
                ]
            }, effective: {
                title: "Чому варто обрати <br/><span>алгоритмічну торгівлю?</span>",
                items: [
                    {
                        title: "Торгівля без «людського фактора»",
                        desc: "Бот не закриє угоду занадто рано через страх і не затримається в збитках через надію. Лише математичне очікування."
                    },
                    {
                        title: "Реальна статистика",
                        desc: "У кожного алгоритму є відкрита статистика мінімум за 6 місяців роботи на реальному рахунку у ліцензованого брокера."
                    },
                    {
                        title: "Пасивний дохід",
                        desc: "Ринок не спить. Бот працює і вдень, і вночі, поки ви відпочиваєте. Це повноцінний пасивний дохід без вашої участі."
                    },
                    {
                        title: "Прозорість і тести",
                        desc: "Кожен алгоритм прогнаний через історичні дані. Ви розумієте логіку роботи системи ще до того, як запустите її."
                    }
                ]
            },
            catalog: {
                title: "Каталог ботів",
                propLabel: "Підходить під проп",
                payingLabel: "Оплата частинами",
                moreDetails: "Детальніше"
            },
            reviews: {
                titleAccent: "Що кажуть ті,",
                title: "хто вже перейшов на ALGO"
            },
            faqTitle: "Відповіді на запитання",
            consult: {
                title: "Складно вибрати свого першого бота?",
                desc: "Ринок пропонує сотні варіантів, але не всі вони підходять під ваш капітал і темперамент. Ми допоможемо підібрати рішення, яке буде комфортним саме для вас.",
                button: "Отримати консультацію"
            }
            , header: {
                howItWorks: "Як працюють",
                advantages: "Переваги",
                catalog: "Каталог ботів",
                reviews: "Відгуки",
                faq: "FAQ",
                selectBot: "Обрати бота"
            },
        }, popup: {
            subtitle: "Forex trading bot",
            title: "Зручний спосіб зв’язку",
            labels: {
                name: "Ваше імʼя",
                contact: "Ваш"
            },
            placeholders: {
                name: "Ваше імʼя"
            },
            channels: {
                tg: "телеграм",
                inst: "інстаграм"
            },
            submit: "Відправити",
            or: "Або напишіть нам",
            writeTg: "Написати в телеграм",
            error: "Сталася помилка при відправці заявки."
        }, thx: {
            title: "Дякуємо! Вашу заявку успішно відправлено.",
            desc: "Наш менеджер опрацює інформацію та зв'яжеться з вами протягом найближчого часу для уточнення деталей. Гарного дня!",
            button: "На головну"
        },


        prop: {
            calculationWords:{
                days: "днів",
                year: "року",
            },
            hero: {
                botName: "PROP EA",
                theme: "Торговий бот для проп-компаній",
                desc: "Надає можливість унікальних зв'язків з проп-компаніями для збільшення прибутку",
                buy: "Придбати бота",
                bestOffer: "Краща пропозиція",
                freeMonth: "Перший місяць підписки безкоштовно",
                slogan: "Універсальність",
                about: "PROP EA — це алгоритм, який враховує всі жорсткі правила проп-компаній, що існують, і був створений для їх обходу.<br/><br/> Він не торгує під час новин, має стоп-лосси для уникнення денного збитку, не залежить від високого спреду і не викликає підозр через достатньо рідкісні позиції.<br/><br/>Водночас, на особистому депозиті він показує себе ще ефективніше через відсутність обмежень, що збільшує його торгову активність і прибутковість.",
                videoFallback: "Ваш браузер не підтримує відео."
            },
            advantages: {
                title: "Переваги",
                items: [
                    {
                        title: "Інтелектуальна точність",
                        desc: "Високий win rate завдяки інтелектуальному аналізу"
                    },
                    {
                        title: "Контроль ризиків",
                        desc: "Має стоп-лосси для кожної позиції, як і обмежувач по просадкам на день за капіталом"
                    },
                    {
                        title: "Захист від волатильності",
                        desc: "Універсальні сет-файли під будь-які завдання: від проп-торгівлі до особистих депозитів."
                    },
                    {
                        title: "Проп-сумісність",
                        desc: "Завдяки відсутності мартингейла та сітки, алгоритм повністю відповідає жорстким правилам ризик-менеджменту більшості проп-компаній."
                    },
                    {
                        title: "Цілодобовий моніторинг",
                        desc: "Алгоритм працює 24/7 без емоцій та втоми, миттєво реагуючи на торгові сигнали в будь-яку сесію."
                    }
                ]
            }
            , botInfoPopup: {
                botInfo: [
                    "Пожиттєвий доступ до оновлень",
                    "2 версії під MT4/MT5",
                    "Відеоінструкції з налаштуванням на кожному етапі",
                    "Сет файли під різні види ризику",
                    "Доступ до закритого каналу з новинами",
                    "Гарантія 100% ідентичності ваших результатів з нашими",
                    "Налаштування бота під проп-компанію"
                ],
                botName: "PROP EA",
                botPrice: 599
            }, faq: [
                {
                    question: "Цей бот залишиться у мене назавжди?",
                    answer: "Так, бот належить вам, але торгує лише за умови активної підписки."
                },
                {
                    question: "Чи можна використовувати бота на особистому депозиті?",
                    answer: "Звісно! Якщо алгоритм працює на пропах, він надійний і для особистого рахунку."
                },
                {
                    question: "Скільки акаунтів я можу підключити?",
                    answer: "Купувати бота знову для кожного акаунта не потрібно, за додатковий акаунт потрібно буде лише сплатити місячну підписку."
                },
                {
                    question: "Як часто можна виводити прибуток з Ifunds?",
                    answer: "Обмежень немає. \n" + "Мінімально 100$, зарахування зазвичай триває протягом кількох годин."
                },
                {
                    question: "Чи можливий злив депозиту?",
                    answer: "Злив депозиту виключений.\n" + "Алгоритм має просунуту систему захисту ризиків.\n" + "З нашими налаштуваннями максимальна просадка не перевищувала 10%."
                }
            ], case: {
                badge: "Кейс",
                title: "Зв'язка",
                desc: "4 виплати за повний торговий місяць."
            },
            howTo: {
                title: "Дізнайтесь як збільшити дохідність Prop EA за допомогою проп-компаній",
                button: "Читати далі"
            }, tests: {
                title: "Результати тестів",
                subtitle: "за останній рік",
                winTrades: "Прибуткові угоди"
            }, buySection: {
                badge: "Найкращий вибір для проп-компаній",
                freeMonth: "Перший місяць підписки безкоштовно",
                title: "Prop EA",
                desc: "Надійний фундамент для автоматичної торгівлі зі стабільними результатами.",
                labels: {
                    monthlyProfit: "Дохідність за місяць",
                    maxDrawdown: "Max drawdown",
                    winrate: "Winrate",
                    price: "Ціна",
                    subscription: "Підписка"
                },
                button: "Придбати бота"
            }, seo: {
                title: "Prop EA — Торговий бот для проп-компаній | Стабільність та контроль ризиків",
                description: "Prop EA: професійний алгоритм для проходження челенджів проп-компаній. Без мартингейла та сітки, вбудований захист від новин та просадок. Отримайте фінансування вже сьогодні!",
                keywords: "Prop EA, проп трейдинг бот, бот для проп компаній, пройти челендж проп, алгоритмічна торгівля, торговий робот без мартингейла, безпечний трейдинг"
            }, calculator: {
                titleAccent: "Розрахуйте",
                title: "свій прибуток",
                sumAndTerm: "Сума та умови",
                labels: {
                    depositType: "Тип депозиту",
                    ownDeposit: "Свій депозит",
                    instantProp: "Instant Проп",
                    monthSubscribe: "Підписка/місяць",
                    month: "місяць",
                    startSum: "Початкова сума",
                    reinvest: "Реінвестувати прибуток",
                    botPrice: "Вартість бота",
                    term: "Термін графіка",
                    months12: "12 місяців",
                    calculateBtn: "Розрахувати дохідність"
                },
                graph: {
                    title: "Графік з розрахунками",
                    placeholder: "Натисніть \"Розрахувати\", щоб побачити графік",
                    netProfit: "Чистий прибуток",
                    totalBalance: "Підсумковий баланс",
                    payback: "Рентабельність бота",
                    period12: "за 12 місяців",
                    endOfTerm: "на кінець терміну",
                    costNotice: "бот коштує $599",
                    legend: {
                        pnl: "PnL за рік",
                        payback: "Окупність",
                        balance: "Баланс",
                        profit: "Прибуток"
                    }
                }
            }, buy: {
                subscribe: "Підписка"
            },
        },
    },

    RU: {
        mql5: {
            title: "Мы официально на маркетплейсе MQL5",
            description: "Теперь наши торговые алгоритмы доступны на крупнейшей независимой площадке для трейдеров.<br/><br/>Мы за абсолютную прозрачность результатов. Проверяйте реальную статистику, историю сделок и подключайте ботов в безопасной среде.",
        },

        prop: {
            calculationWords:{
                days: "дней",
                year: "года",
            },
            buy: {
                subscribe: "Подписка"
            },
            botInfoPopup: {
                botInfo: [
                    "Пожизненный доступ к обновлениям",
                    "2 версии под MT4/MT5",
                    "Видеоинструкции с настройкой на каждом этапе",
                    "Сет-файлы под разные виды риска",
                    "Доступ к закрытому каналу с новостями",
                    "Гарантия 100% идентичности ваших результатов с нашими",
                    "Настройка бота под проп-компанию"
                ],
                botName: "PROP EA",
                botPrice: 599
            },
            calculator: {
                titleAccent: "Рассчитайте",
                title: "свою прибыль",
                sumAndTerm: "Сумма и условия",
                labels: {
                    depositType: "Тип депозита",
                    ownDeposit: "Свой депозит",
                    monthSubscribe: "Подписка/месяц",
                    month: "месяц",
                    instantProp: "Instant Проп",
                    startSum: "Начальная сумма",
                    reinvest: "Реинвестировать прибыль",
                    botPrice: "Стоимость бота",
                    term: "Срок графика",
                    months12: "12 месяцев",
                    calculateBtn: "Рассчитать доходность"
                },
                graph: {
                    title: "График с расчетами",
                    placeholder: "Нажмите \"Рассчитать\", чтобы увидеть график",
                    netProfit: "Чистая прибыль",
                    totalBalance: "Итоговый баланс",
                    payback: "Рентабельность бота",
                    period12: "за 12 месяцев",
                    endOfTerm: "на конец срока",
                    costNotice: "бот стоит $599",
                    legend: {
                        pnl: "PnL за год",
                        payback: "Окупаемость",
                        balance: "Баланс",
                        profit: "Прибыль"
                    }
                }
            },
            seo: {
                title: "Prop EA — Торговый бот для проп-компаний | Стабильность и контроль рисков",
                description: "Prop EA: профессиональный алгоритм для прохождения челленджей проп-компаний. Без мартингейла и сетки, встроенная защита от новостей и просадок. Получите финансирование уже сегодня!",
                keywords: "Prop EA, проп трейдинг бот, бот для проп компаний, пройти челлендж проп, алгоритмическая торговля, торговый робот без мартингейла, безопасный трейдинг"
            },
            buySection: {
                badge: "Лучший выбор для проп-компаний",
                freeMonth: "Первый месяц подписки бесплатно",
                title: "Prop EA",
                desc: "Надежный фундамент для автоматической торговли со стабильными результатами.",
                labels: {
                    monthlyProfit: "Доходность за месяц",
                    maxDrawdown: "Max drawdown",
                    winrate: "Winrate",
                    price: "Цена",
                    subscription: "Подписка"
                },
                button: "Купить бота"
            },
            tests: {
                title: "Результаты тестов",
                subtitle: "за последний год",
                winTrades: "Прибыльные сделки"
            },
            case: {
                badge: "Кейс",
                title: "Связка",
                desc: "4 выплаты за полный торговый месяц."
            },
            howTo: {
                title: "Узнайте как увеличить доходность Prop EA с помощью проп-компаний",
                button: "Читать далее"
            },
            faq: [
                {
                    question: "Этот бот останется у меня навсегда?",
                    answer: "Да, бот принадлежит вам, но торгует только при активной подписке."
                },
                {
                    question: "Можно ли использовать бота на личном депозите?",
                    answer: "Конечно! Если алгоритм работает на пропах, он надежен и для личного счета."
                },
                {
                    question: "Сколько аккаунтов я могу подключить?",
                    answer: "Покупать снова бота для каждого аккаунта не нужно, за дополнительный аккаунт нужно будет оплатить месячную подписку."
                },
                {
                    question: "Как часто можно выводить прибыль с Ifunds?",
                    answer: "Ограничений нет. \n" + "Минимально 100$, зачисление обычно происходит в течение нескольких часов."
                },
                {
                    question: "Возможен ли слив депозита?",
                    answer: "Слив депозита исключен.\n" + "Алгоритм имеет продвинутую систему защиты рисков.\n" + "При наших настройках максимальная просадка не превышала 10%."
                }
            ],
            hero: {
                botName: "PROP EA",
                theme: "Торговый бот для проп-компаний",
                desc: "Имеет более 7 месяцев подтвержденной статистики и 10 лет тестов со стабильными результатами.",
                buy: "Купить бота",
                bestOffer: "Лучшее предложение",
                freeMonth: "Первый месяц подписки бесплатно",
                slogan: "Прирост вашего капитала",
                about: "PROP EA — это алгоритм, который учитывает все существующие жесткие правила проп-компаний и был создан для их прохождения.<br/><br/> Он не торгует во время новостей, использует стоп-лоссы для предотвращения дневного убытка, не зависит от высокого спреда и не вызывает подозрений благодаря достаточно редким позициям.<br/><br/>В то же время, на личном депозите он показывает себя еще эффективнее из-за отсутствия ограничений, что увеличивает его торговую активность и доходность.",
                videoFallback: "Ваш браузер не поддерживает видео."
            },
            advantages: {
                title: "Преимущества",
                items: [
                    {
                        title: "Интеллектуальная точность",
                        desc: "Высокий win rate благодаря интеллектуальному анализу"
                    },
                    {
                        title: "Контроль рисков",
                        desc: "Торгует со стоп-лоссами без мартингейла и усреднений"
                    },
                    {
                        title: "Защита от волатильности",
                        desc: "Имеет новостной фильтр для исключения торговли в волатильное время"
                    },
                    {
                        title: "Проп-совместимость",
                        desc: "Благодаря отсутствию мартингейла и сетки, алгоритм полностью соответствует жестким правилам риск-менеджмента большинства проп-компаний."
                    },
                    {
                        title: "Круглосуточный мониторинг",
                        desc: "Алгоритм работает 24/7 без эмоций и усталости, мгновенно реагируя на торговые сигналы в любую сессию."
                    }
                ]
            }
        },


        menu: {
            how: "Как работают",
            advantages: "Преимущества",
            catalog: "Каталог ботов",
            reviews: "Отзывы",
            faq: "FAQ",
        },
        buttons: {
            selectBot: "Выбрать бота",
            openMql: "Открыть в MQL5",
        },

        terra: {
            seo: {
                title: "Terra EA — Торговый бот с самой длинной статистикой в Украине",
                description: "Terra EA: более 2 лет подтверждённой статистики, 23 из 24 месяцев в плюс. Надёжный алгоритм для MT4/MT5 с годовой доходностью +20% и контролем риска.",
                keywords: "Terra EA, торговый робот статистика, форекс бот скачать, автоматическая торговля MT4, алгоритм RSI Bollinger, стабильный заработок на трейдинге"
            },

            hero: {
                theme: "Бот с самой длинной статистикой в Украине",
                desc: "Более 2 лет подтверждённой статистики со стабильными результатами",
                buy: "Приобрести бота",
                slogan: "Основа вашего капитала",
                about: "Как земля <span>является фундаментом всего живого,</span> Terra EA создаёт надёжную основу <span>для автоматической торговли со стабильными результатами.</span><br/><br/>Алгоритм создан для тех, <span>кто ценит уверенность.</span><br/><br/>Стратегия имеет <span>положительное математическое ожидание</span> и проверена временем и рынком.",
                videoFallback: "Ваш браузер не поддерживает видео."
            },

            advantages: {
                titleAccent: "Интеллектуальный подход",
                title: "к трейдингу",
                items: [
                    {
                        title: "Комбинация индикаторов",
                        desc: "В основе алгоритма лежит синергия RSI, Bollinger Bands и ATR."
                    },
                    {
                        title: "Умный риск-менеджмент",
                        desc: "Грамотное управление капиталом, хеджирование и мартингейл только при необходимости."
                    },
                    {
                        title: "Money менеджмент",
                        desc: "Terra демонстрирует эффективную работу с минимальными просадками при депозите от 1000$, что редко для мартингейл-ботов."
                    }
                ]
            }, results: {
                title: "Результаты говорят сами за себя",
                subtitle: "23 из 24 месяцев торговли закрыты в плюс.",
                stats: [
                    {label: "Year profit", value: "+25%"},
                    {label: "Max drawdown", value: "16.5%"},
                    {label: "Winrate", value: "72.3%"}
                ],
                button: "Смотреть статистику"
            },

            video: {
                titleAccent: "Видео-демонстрация",
                title: "работы бота"
            },

            reviews: {
                titleAccent: "Что говорят те,",
                title: "кто используют TERRA EA"
            }, reviews1: {
                more: "Больше отзывов"
            },

            tests: {
                title: "Результаты тестов",
                titleAccent: "за последние 10 лет",

                period: "Период тестирования",
                timeframe: "Таймфрейм",
                timeframeValue: "1 час (H1)",
                dates: "Даты тестирования",

                depositProfit: "Депозит и прибыль",
                startDeposit: "Начальный депозит",
                netProfit: "Чистая прибыль",

                pairs: "Валютные пары",

                risk: "Риск",
                maxDrawdown: "Максимальная просадка",

                trades: "Статистика сделок"
            },

            buy: {
                desc: "Надёжный фундамент для автоматической торговли со стабильными результатами.",
                price: "Цена",
                buy: "Купить",
                parts: "Оплата частями"
            },

            stats: {
                yearProfit: "Year profit",
                maxDrawdown: "Max drawdown",
                winrate: "Winrate"
            },

            footer: {
                instagram: "Instagram",
                telegram: "Telegram",
                youtube: "Youtube"
            },
            reviewsList: [
                {
                    name: "Taras O.",
                    text: "Пользуюсь ботом с ноября и очень доволен результатом. Искал инструмент для пассивного дохода с низкими рисками — этот вариант подошел идеально. За два месяца получил 4% чистой прибыли благодаря системе сложного процента. Бот полностью автоматический: настроил с помощью продавца и больше не вмешивался. Особенно радует, что система сама выключается во время сильных новостей, минимизируя риски. Ожидаю около 40% годовых. Рекомендую как надежный и безопасный инструмент.",
                },
                {
                    name: "Max S.",
                    text: "Бот демонстрирует отличную работу. Использую его на минимальных рисках для стабильного прироста капитала. Для меня это стала отличная альтернатива другим способам диверсификации средств под процент. Огромным плюсом является то, что бот интегрируется с биржей Bybit, и я могу держать весь депозит на собственном счету, что добавляет уверенности в безопасности активов. Инструмент удобный, понятный и, главное, приносит прогнозируемую прибыль без лишних хлопот и ежедневного мониторинга.",
                },
                {
                    name: "Dmytro P.",
                    text: "Пользуюсь ботом «Терра» уже три месяца. Решил протестировать стратегию на высоких рисках и результат поразил — имею +48% к депозиту. Очень круто, что разработчик постоянно обновляет настройки и всегда на связи в чате, отвечая на вопросы. Кроме технической части, импонирует честность автора: слова в постах всегда соответствуют реальным цифрам. Это вызывает большое доверие. С нетерпением жду новых релизов и алгоритмов, так как этот продукт однозначно стоит внимания.",
                },
                {
                    name: "Valerii R.",
                    text: "Приобрел этот софт около месяца назад и уже могу сделать первые выводы. Процесс настройки прошел быстро, алгоритм стратегии понятен даже без глубоких технических знаний. Бот работает очень четко, без технических сбоев или ошибок в исполнении ордеров. Это именно тот продукт, который соответствует заявленным характеристикам. Пока все идет по плану, результаты стабильные, поэтому могу смело советовать этого бота тем, кто ценит качество исполнения и понятную логику торговли.",
                },
                {
                    name: "Sergii I.",
                    text: "Работаю с ботом «Терра» уже пятый месяц. Сознательно пошел на эксперимент и занизил уровень безопасности (завысил риски), хотя разработчик предупреждал о возможных последствиях. Несмотря на это, результатом за этот период очень доволен — бот выдержал рыночные движения и показал хороший плюс. Система работает стабильно даже при агрессивных настройках. Спасибо Вове за качественный продукт, который дает возможность гибко управлять своей стратегией и получать желаемую прибыль на дистанции.",
                },
            ],
            botInfoPopup: {
                botInfo: [
                    "Безлимитное количество активаций бота",
                    "Пожизненный доступ к обновлениям",
                    "2 версии под MT4/MT5",
                    "Видеоинструкции с настройкой на каждом этапе",
                    "Сет-файлы под разные виды риска",
                    "Доступ к закрытому каналу с новостями",
                    "Гарантия 100% идентичности ваших результатов с нашими"
                ],
                botName: "TERRA EA",
                botPrice: 1000
            }, calculator: {
                titleAccent: "Рассчитайте свою",
                title: "долгосрочную доходность",
                themes: {
                    sumAndTerm: "Сумма и срок",
                    interest: "Начисление процентов",
                    refill: "Пополнение"
                },
                labels: {
                    startSum: "Начальная сумма",
                    unit: "Единица измерения",
                    term: "Срок",
                    frequency: "Периодичность",
                    rate: "Процентная ставка",
                    sum: "Сумма"
                },
                units: {
                    year: "Год",
                    month: "Месяц",
                    yearly: "Ежегодно",
                    monthly: "Ежемесячно"
                },
                warnings: {
                    startSum: "Сумма, с которой начинаются инвестиции",
                    term: "Количество лет/месяцев, в течение которых вы планируете инвестировать средства",
                    rate: "Размер годового/месячного дохода в процентах",
                    refill: "Сумма, на которую планируете пополнять"
                },
                button: "Рассчитать доходность",
                table: {
                    tableName: "Таблица с расчетами",
                    balance: "Баланс",
                    addedYear: "Пополнено (год)",
                    addedMonth: "Пополнено (мес.)",
                    totalAdded: "Суммарные инвестиции",
                    incomeYear: "Годовой доход",
                    incomeMonth: "Месячный доход",
                    totalIncome: "Общий доход",
                    finalBalance: "Итоговый баланс",
                    description: "Terra EA в среднем делает стабильные +25% в год/2.1% в месяц.<br/>Чем больше срок инвестиций, тем больше магия сложного процента!",
                    descriptionAero: "Aero EA в среднем делает стабильные +30% в год/2.5% в месяц.<br/>Чем больше срок инвестиций, тем больше магия сложного процента!",
                    descriptionHydro: "Hydro EA в среднем делает стабильные +50% в год/4.2% в месяц.<br/>Чем больше срок инвестиций, тем больше магия сложного процента!"
                }
            }


        }, aero: {
            reviewsList: [
                {
                    name: "Dmytro P.",
                    text: "Пишу отзыв по результатам первой недели торгов. Приятно, что все сделки четко сходятся с мониторингом на Myfxbook, профит идет абсолютно закономерный. Начало отличное, так что надеюсь на долгое и плодотворное сотрудничество.",
                },
                {
                    name: "Mykola F.",
                    text: "За первый месяц пользования ботом получил такой результат ⬆️ +5% чистой прибыли к депозиту. Работает стабильно, без лишнего риска, с четкой логикой входов и выходов. Для меня это хороший и прогнозируемый результат.",
                },
                {
                    name: "Sergii H.",
                    text: "Привет! Пользуюсь ботом Aero уже ровно два месяца. За это время на моем личном депозите на бирже Bybit он наторговал +321$. Результатом полностью доволен, бот показывает себя отлично на дистанции.",
                },
                {
                    name: "Alex D.",
                    text: "Пишу отзыв о своем опыте использования ботов. Купил сразу два алго — очень понравилась подача и презентация. Запустил на одном счету и получил хорошие цифры. Поддержка, консультации и сопровождение — на высоком уровне.",
                },
                {
                    name: "Dmytro S.",
                    text: "Всем привет. Прошло два месяца с момента покупки бота Aero. На личном счету Bybit чистая прибыль составила уже +321$. Система работает стабильно и полностью оправдывает вложенные средства.",
                },
            ],
            botInfoPopup: {
                botInfo: [
                    "Безлимитное количество активаций бота",
                    "Пожизненный доступ к обновлениям",
                    "2 версии под MT4/MT5",
                    "Видеоинструкции с настройкой на каждом этапе",
                    "Сет-файлы под разные виды риска",
                    "Доступ к закрытому каналу с новостями",
                    "Гарантия 100% идентичности ваших результатов с нашими",
                    "Настройка бота под проп-компанию"
                ],
                botName: "AERO EA",
                botPrice: 1200
            }, hero: {
                botName: "Aero EA",
                theme: "Торговый бот с самыми низкими просадками",
                desc: "Более 11 месяцев подтвержденной статистики и 10 лет тестов со стабильными результатами.",
                buy: "Приобрести бота",
                slogan: "Безопасность вашего капитала",
                about: "Aero — это стихия воздуха; он может быть как спокойным, <span>словно легкий бриз, так и динамичным, как шторм,</span> превращая ветер в шквал благодаря настраиваемым уровням риска.<br/><br/>В его основе лежит алгоритм распознавания паттернов — kNN (k-ближайших соседей), <span>метод машинного обучения, обученный на данных о цене золота за 25+ лет.</span><br/><br/>Результат: <span>короткие, чистые сделки с неизменно высоким винрейтом и четко определенным риском в каждой позиции.</span>",
                videoFallback: "Ваш браузер не поддерживает видео."
            },
            seo: {
                title: "Aero EA — Безопасный торговый бот с просадкой 3.7%",
                description: "Aero EA: алгоритм на базе AI для XAUUSD (Gold). Без мартингейла и сеток. Идеально подходит для проп-компаний. Winrate 86.8% и стабильная прибыль.",
                keywords: "Aero EA, бот для проп компаний, безопасный трейдинг бот, робот для золота XAUUSD, трейдинг без мартингейла, торговые боты AI"
            },
            advantages: {
                title: "Преимущества",
                items: [
                    {
                        title: "Подходит для проп-компаний",
                        desc: "Так как он не использует запрещенных стратегий, Aero подходит для большинства популярных проп-компаний."
                    },
                    {
                        title: "Адаптация к рынку",
                        desc: "Алгоритм работает на пробой ключевых ценовых уровней и подстраивается под различные стадии рынка."
                    },
                    {
                        title: "Гибкость под любой стиль торговли",
                        desc: "Идеален как для консервативных, так и для агрессивных трейдеров. Вы сами контролируете стиль торговли."
                    },
                    {
                        title: "Полная автоматизация",
                        desc: "Aero EA работает в фоновом режиме, полностью автоматизирован и не требует постоянного участия."
                    }
                ]
            }, results: {
                subtitle: "На live счету Aero демонстрирует феноменальный результат с доходностью 2%/месяц при просадке 3.7%",
                winrateText: "При этом его winrate достиг показателя в 86.8%.",
                stats: [
                    {label: "Year profit", value: "+30%"},
                    {label: "Max drawdown", value: "3.7%"},
                    {label: "Winrate", value: "86.8%"}
                ],
                button: "Смотреть статистику"
            },
            video: {
                title: "<span>Видео-демонстрация</span><br/> работы бота"
            },
            propInfo: {
                title: "Узнайте как увеличить доходность Aero с помощью проп-компаний",
                button: "Читать больше"
            }, reviews: {
                titleAccent: "Что говорят те,",
                title: "кто пользуются AERO EA"
            },
            tests: {
                winTrades: "Прибыльные сделки"
            }, buy: {
                desc: "Надежный фундамент для автоматической торговли со стабильными результатами.",
            }
        }, hydro: {
            reviewsList: [
                {
                    name: "Valerii R.",
                    text: "Купил бота две недели назад, заинтересовала детальная статистика 📈 Тестировал его неделю, так как в этой сфере давно и знаю, что часто на словах одно, а на практике совсем другое. Могу подтвердить — все соответствует заявленному, трейды сходятся со статистикой.",
                },
                {
                    name: "Eduard F.",
                    text: "Бот успешно прошел первую фазу на FTMO за 22 торговых дня ✅ Вторую фазу верификации закрыл всего за 4 дня. Результатом полностью доволен, работает стабильно, без сюрпризов, соблюдает риск-менеджмент и показывает прогнозируемый результат.",
                },
                {
                    name: "Dmytro K.",
                    text: "Сделал свой первый вывод средств с трейдинга за долгий период времени. Честно — очень приятные ощущения, особенно когда результат получен без постоянного контроля. Отличный бонус и подарок к будущим праздникам, который реально мотивирует двигаться дальше.",
                },
                {
                    name: "Dmytro A.",
                    text: "Имею результат в +1200$ на личном счету Bybit! Бот торгует 3 месяца, планирую увеличивать депозит в ближайшее время",
                },
                {
                    name: "Nikolay S.",
                    text: "Привет еще раз, хочу написать отзыв о работе бота и, собственно, о твоей работе. Сначала бот покупался под проп, сразу скажу, что был предупрежден, что все риски с пропами беру на себя. Что касается личного депозита, бот со всеми взлетами и падениями принес 4-5% за период с 18 августа.",
                },
                {
                    name: "Volodymyr D.",
                    text: "У меня получилось за месяц с учетом стопа на Лоу риск и хай риск по 20%😂",
                },
            ],
            botInfoPopup: {
                botInfo: [
                    "Безлимитное количество активаций бота",
                    "Пожизненный доступ к обновлениям",
                    "2 версии под MT4/MT5",
                    "Видеоинструкции с настройкой на каждом этапе",
                    "Сет-файлы под разные виды риска",
                    "Доступ к закрытому каналу с новостями",
                    "Гарантия 100% идентичности ваших результатов с нашими",
                    "Настройка бота под проп-компанию"
                ],
                botName: "HYDRO EA",
                botPrice: 2000
            }, hero: {
                botName: "Hydro EA",
                theme: "Торговый бот с самой высокой доходностью",
                desc: "Более 7 месяцев подтвержденной статистики и 10 лет тестов со стабильными результатами.",
                buy: "Приобрести бота",
                slogan: "Прирост вашего капитала",
                about: "Hydro сочетает спокойствие глубоких вод и силу приливов, <span>помогая находить баланс между стабильностью и прибыльностью.</span><br/><br/>Он быстро реагирует на изменения рынка, <span>находя оптимальные точки входа</span> и выхода с высокой точностью.<br/><br/>Обладая Winrate выше 90% и доходностью более 4.5% в месяц, <span>Hydro проявляет себя как совершенный скальпинг-бот, максимально имитирующий торговое поведение человека.</span>",
                videoFallback: "Ваш браузер не поддерживает видео."
            },
            seo: {
                title: "Hydro EA — Торговый бот с Winrate 91.9% и высокой доходностью",
                description: "Hydro EA: профессиональный скальпинг-бот для Gold (XAUUSD). Средняя доходность 5% в месяц, защита от волатильности и работа без мартингейла. Лучший выбор для управления капиталом.",
                keywords: "Hydro EA, скальпинг бот, высокодоходный торговый робот, бот для золота, Winrate 90 трейдинг, автоматизация XAUUSD, профессиональные торговые алгоритмы"
            },
            advantages: {
                title: "Преимущества",
                items: [
                    {
                        title: "Интеллектуальная точность",
                        desc: "Высокий win rate благодаря интеллектуальному анализу"
                    },
                    {
                        title: "Контроль рисков",
                        desc: "Торгует со стоп-лоссами без мартингейла и усреднений"
                    },
                    {
                        title: "Защита от волатильности",
                        desc: "Имеет фильтр новостей для исключения торговли в волатильное время"
                    },
                    {
                        title: "Проп-совместимость",
                        desc: "Благодаря отсутствию мартингейла и сетки, алгоритм полностью соответствует жестким правилам риск-менеджмента большинства проп-компаний."
                    },
                    {
                        title: "Круглосуточный мониторинг",
                        desc: "Алгоритм работает 24/7 без эмоций и усталости, мгновенно реагируя на торговые сигналы в любую сессию."
                    }
                ]
            }, results: {
                subtitle: "На публичном счету Hydro демонстрирует феноменальный результат со средней доходностью в 5% в месяц.",
                winrateText: "При этом его winrate достиг показателя в 91.9%.",
                stats: [
                    {label: "Year profit", value: "+50%"},
                    {label: "Max drawdown", value: "14.3%"},
                    {label: "Winrate", value: "91.9%"}
                ]
            },
            propInfo: {
                title: "Узнайте как увеличить доходность Hydro с помощью проп-компаний"
            }, reviews: {
                titleAccent: "Что говорят те,",
                title: "кто пользуются HYDRO EA"
            },
            tests: {
                timeframeValue: "1 день ( D1 )"
            }
        }, home: {
            bestOfferProp:"Лучший выбор для проп-компаний",
            piecePay: "Доступная оплата частями",
            trailer:"Трейлер",
            mainVideoText:"Что мы создаем",
            mainVideoDesc:"Наш официальный тизер — философия, элементы и стандарты, лежащие в основе каждой выпускаемой нами системы.",
            mainVideoButton:"Изучите Algo",
            botsList: [
                {
                    name: "Terra EA",
                    description: "Бот с самой долгой публичной статистикой в Украине.",
                    advantages: {yearProfit: "+25%", maxDrawDown: "16.5%", winRate: "72.3%"},
                    price: 1000,
                    href: "/terra",
                    prop: false,
                    paying: true,
                },
                {
                    name: "Aero EA",
                    description: "Бот с самой низкой просадкой в ассортименте.",
                    advantages: {yearProfit: "+30%", maxDrawDown: "3.7%", winRate: "86.8%"},
                    price: 1200,
                    href: "/aero",
                    prop: true,
                    paying: true,
                },
                {
                    name: "Hydro EA",
                    description: "Бот с самой высокой доходностью в ассортименте.",
                    advantages: {yearProfit: "+50%", maxDrawDown: "14.3%", winRate: "91.9%"},
                    price: 2000,
                    href: "/hydro",
                    prop: true,
                    paying: true
                }
            ],
            reviewsList: [
                {
                    name: "Valerii R.",
                    text: "Купил бота две недели назад, заинтересовала детальная статистика 📈 Тестировал его неделю, так как в этой сфере давно и знаю, что слова часто расходятся с практикой. Подтверждаю — всё соответствует заявленному, трейды сходятся со статистикой."
                },
                {
                    name: "Eduard F.",
                    text: "Бот успешно прошел первую фазу на FTMO за 22 торговых дня ✅ Вторую фазу верификации закрыл всего за 4 дня. Результатом полностью доволен, работает стабильно, без сюрпризов, соблюдает риск-менеджмент."
                },
                {
                    name: "Dmytro K.",
                    text: "Сделал свой первый вывод средств с трейдинга за долгий период. Честно — очень приятные ощущения, особенно когда результат получен без постоянного контроля. Отличный бонус и подарок к праздникам."
                },
                {
                    name: "Andry D.",
                    text: "Пишу отзыв об опыте использования ботов. Купил сразу два алго — очень понравилась подача и презентация. Запустил на одном счету и получил хорошие цифры. Поддержка и консультации — на высоком уровне."
                },
                {
                    name: "Mykola P.",
                    text: "За первый месяц пользования ботом получил +5% чистой прибыли к депозиту. Работает стабильно, без лишнего риска, с четкой логикой входов и выходов. Для меня это хороший прогнозируемый результат."
                },
                {
                    name: "Max S.",
                    text: "Долго не доходили руки оставить фидбек по Терре. За 3 месяца на повышенном риске получил +48%. Очень доволен ботом, обновлениями и поддержкой. Отдельное уважение за честность — цифры соответствуют реальности."
                }
            ],
            faq: [
                {
                    question: "Как подобрать бота?",
                    answer: "Все риски по каждому боту прописаны на его странице. Мы работаем исключительно со стабильными настройками риска, которые не превышают 15-20% просадки от депозита."
                },
                {
                    question: "Нужно ли постоянно держать компьютер включенным?",
                    answer: "Нет. Боты работают на удаленных серверах. Вы можете выключить телефон или ноутбук — процесс не прервется."
                },
                {
                    question: "Нужен ли большой опыт в трейдинге?",
                    answer: "Абсолютно нет, все что нужно — это создать аккаунт и подключить бота. Видео-инструкции будут доступны сразу после покупки."
                },
                {
                    question: "Можно ли потерять весь депозит?",
                    answer: "Наши боты протестированы на разных этапах рынка и в критических ситуациях. С нашими настройками слив депозита невозможен."
                },
                {
                    question: "Как получить консультацию?",
                    answer: "Для правильного подбора рекомендуем ознакомиться с каждым ботом или обратиться за консультацией в телеграм, где мы определим подходящий вам алгоритм."
                }
            ], hero: {
                title: "Ваш капитал растет — без вашего участия",
                desc: "Торговые боты, которые самостоятельно работают по четкой стратегии — с минимальной просадкой и реальной историей на живых счетах.",
                button: "Выбрать бота"
            }, stats: {
                title: "<span>Наша команда уже автоматизировала трейдинг</span><br/>для многих клиентов, поможем и вам",
                management: "в управлении",
                items: [
                    {num: "2", desc: "Года на рынке"},
                    {num: "4", desc: "Профитных бота"},
                    {num: "5", desc: "Счетов с live статистикой"},
                    {num: "+80%", desc: "За 2025 год"}
                ]
            },
            steps: {
                title: "<span>Путь от настройки</span> до первой сделки",
                items: [
                    {
                        title: "Выбор алгоритма",
                        desc: "Вы определяете свои цели и допустимый риск. В нашем каталоге есть решения как для консервативного накопления, так и для активной торговли."
                    },
                    {
                        title: "Подключение",
                        desc: "Бот устанавливается на ваш аккаунт за пару кликов. Вы получаете все инструкции и лицензию для активации."
                    },
                    {
                        title: "Автономная торговля",
                        desc: "Алгоритм сканирует рынок 24/7. Как только условия стратегии совпадают, бот мгновенно открывает позицию."
                    },
                    {
                        title: "Мониторинг и результат",
                        desc: "Вы следите за статистикой в реальном времени. В любой момент работу бота можно приостановить или изменить."
                    }
                ]
            }, effective: {
                title: "Почему стоит выбрать <br/><span>алгоритмическую торговлю?</span>",
                items: [
                    {
                        title: "Торговля без «человеческого фактора»",
                        desc: "Бот не закроет сделку слишком рано из-за страха и не пересидит в убытках из-за надежды. Только математическое ожидание."
                    },
                    {
                        title: "Реальная статистика",
                        desc: "У каждого алгоритма есть открытая статистика минимум за 6 месяцев работы на реальном счету у лицензированного брокера."
                    },
                    {
                        title: "Пассивный доход",
                        desc: "Рынок не спит. Бот работает и днем, и ночью, пока вы отдыхаете. Это полноценный пассивный доход без вашего участия."
                    },
                    {
                        title: "Прозрачность и тесты",
                        desc: "Каждый алгоритм прогнан через исторические данные. Вы понимаете логику работы системы еще до того, как запустите ее."
                    }
                ]
            },
            catalog: {
                title: "Каталог ботов",
                propLabel: "Подходит под проп",
                payingLabel: "Оплата частями",
                moreDetails: "Подробнее"
            },
            reviews: {
                titleAccent: "Что говорят те,",
                title: "кто уже перешел на ALGO"
            },
            faqTitle: "Ответы на вопросы",
            consult: {
                title: "Сложно выбрать своего первого бота?",
                desc: "Рынок предлагает сотни вариантов, но не все они подходят под ваш капитал и темперамент. Мы поможем подобрать решение, которое будет комфортным именно для вас.",
                button: "Получить консультацию"
            }, header: {
                howItWorks: "Как работают",
                advantages: "Преимущества",
                catalog: "Каталог ботов",
                reviews: "Отзывы",
                faq: "FAQ",
                selectBot: "Выбрать бота"
            },
        }, popup: {
            subtitle: "Forex trading bot",
            title: "Удобный способ связи",
            labels: {
                name: "Ваше имя",
                contact: "Ваш"
            },
            placeholders: {
                name: "Ваше имя"
            },
            channels: {
                tg: "телеграм",
                inst: "инстаграм"
            },
            submit: "Отправить",
            or: "Или напишите нам",
            writeTg: "Написать в телеграм",
            error: "Произошла ошибка при отправке заявки."
        }, thx: {
            title: "Спасибо! Ваша заявка успешно отправлена.",
            desc: "Наш менеджер обработает информацию и свяжется с вами в ближайшее время для уточнения деталей. Хорошего дня!",
            button: "На главную"
        }
    },

    EN:{
        prop: {
            calculationWords:{
                days: "days",
                year: "year",
            },
            buy: {
                subscribe: "Subscription"
            },
            botInfoPopup: {
                botInfo: [
                    "Lifetime access to updates",
                    "2 versions for MT4/MT5",
                    "Video instructions with step-by-step setup",
                    "Set-files for various risk levels",
                    "Access to a private news channel",
                    "100% guarantee that your results will match ours",
                    "Bot configuration for prop firms"
                ],
                botName: "PROP EA",
                botPrice: 599
            },
            calculator: {
                titleAccent: "Calculate",
                title: "your profit",
                sumAndTerm: "Amount and conditions",
                labels: {
                    depositType: "Deposit type",
                    ownDeposit: "Own deposit",
                    monthSubscribe: "Subscription/month",
                    month: "month",
                    instantProp: "Instant Prop",
                    startSum: "Initial amount",
                    reinvest: "Reinvest profit",
                    botPrice: "Bot price",
                    term: "Chart period",
                    months12: "12 months",
                    calculateBtn: "Calculate profitability"
                },
                graph: {
                    title: "Calculation chart",
                    placeholder: "Click \"Calculate\" to see the chart",
                    netProfit: "Net profit",
                    totalBalance: "Total balance",
                    payback: "Bot ROI",
                    period12: "for 12 months",
                    endOfTerm: "at the end of the term",
                    costNotice: "bot costs $599",
                    legend: {
                        pnl: "PnL per year",
                        payback: "Payback",
                        balance: "Balance",
                        profit: "Profit"
                    }
                }
            },
            seo: {
                title: "Prop EA — Trading bot for prop firms | Stability and risk control",
                description: "Prop EA: a professional algorithm for passing prop firm challenges. No martingale or grid, built-in protection against news and drawdowns. Get funded today!",
                keywords: "Prop EA, prop trading bot, bot for prop firms, pass prop challenge, algorithmic trading, trading robot no martingale, safe trading"
            },
            buySection: {
                badge: "Best For Prop-Companies",
                freeMonth: "First month of subscription for free",
                title: "Prop EA",
                desc: "A reliable foundation for automated trading with stable results.",
                labels: {
                    monthlyProfit: "Monthly profitability",
                    maxDrawdown: "Max drawdown",
                    winrate: "Winrate",
                    price: "Price",
                    subscription: "Subscription"
                },
                button: "Buy Bot"
            },
            tests: {
                title: "Test results",
                subtitle: "over the last year",
                winTrades: "Profitable trades"
            },
            case: {
                badge: "Case Study",
                title: "Setup",
                desc: "4 payouts in a full trading month."
            },
            howTo: {
                title: "Find out how to increase Prop EA profitability with prop firms",
                button: "Read more"
            },
            faq: [
                {
                    question: "Will I keep this bot forever?",
                    answer: "Yes, the bot belongs to you, but it only trades while the subscription is active."
                },
                {
                    question: "Can I use the bot on a personal deposit?",
                    answer: "Of course! If the algorithm works on prop accounts, it is reliable for a personal account as well."
                },
                {
                    question: "How many accounts can I connect?",
                    answer: "You don't need to buy the bot again for each account; you only need to pay the monthly subscription for each additional account."
                },
                {
                    question: "How often can I withdraw profit from Ifunds?",
                    answer: "There are no restrictions. Minimum $100, and funds are usually credited within a few hours."
                },
                {
                    question: "Is it possible to blow the deposit?",
                    answer: "Blowing the deposit is excluded.\n" + "The algorithm features an advanced risk protection system.\n" + "With our settings, the maximum drawdown has not exceeded 10%."
                }
            ],
            hero: {
                botName: "PROP EA",
                theme: "Trading bot for prop firms",
                desc: "Features over 7 months of verified statistics and 10 years of tests with stable results.",
                buy: "Buy Bot",
                bestOffer: "Best Offer",
                freeMonth: "First month of subscription for free",
                slogan: "Growth of your capital",
                about: "PROP EA is an algorithm designed specifically to pass prop firm challenges, accounting for all their strict rules.<br/><br/> It avoids trading during news events, uses stop-losses to prevent daily losses, is independent of high spreads, and does not trigger suspicion due to its relatively infrequent positions.<br/><br/>At the same time, it performs even more effectively on a personal deposit due to the lack of restrictions, which increases its trading activity and profitability.",
                videoFallback: "Your browser does not support the video tag."
            },
            advantages: {
                title: "Advantages",
                items: [
                    {
                        title: "Intelligent Precision",
                        desc: "High win rate thanks to intelligent analysis"
                    },
                    {
                        title: "Risk Control",
                        desc: "Trades with stop-losses, without martingale or averaging"
                    },
                    {
                        title: "Volatility Protection",
                        desc: "Includes a news filter to exclude trading during volatile periods"
                    },
                    {
                        title: "Prop Compatibility",
                        desc: "Due to the absence of martingale and grid, the algorithm fully complies with the strict risk management rules of most prop firms."
                    },
                    {
                        title: "24/7 Monitoring",
                        desc: "The algorithm works 24/7 without emotion or fatigue, instantly reacting to trading signals in any session."
                    }
                ]
            }
        },

        menu: {
            how: "How it works",
            advantages: "Advantages",
            catalog: "Bot Catalog",
            reviews: "Reviews",
            faq: "FAQ",
        },
        buttons: {
            selectBot: "Select Bot",
            openMql: "Open in MQL5",
        },
        mql5:{
            title: "We are officially on the MQL5 Marketplace",
            description: "Our trading algorithms are now available on the largest independent marketplace for traders.<br/><br/>We stand for absolute transparency of results. Check real-time statistics, trade history, and connect bots in a secure environment.",
        },

        terra: {
            seo: {
                title: "Terra EA — Trading bot with the longest track record in Ukraine",
                description: "Terra EA: over 2 years of verified statistics, 23 out of 24 months in profit. A reliable algorithm for MT4/MT5 with +20% annual return and risk control.",
                keywords: "Terra EA, trading robot statistics, forex bot download, automated trading MT4, RSI Bollinger algorithm, stable trading income"
            },

            hero: {
                theme: "The bot with the longest track record in our lineup",
                desc: "Over 2 years of verified statistics with stable results",
                buy: "Purchase bot",
                slogan: "The foundation of your capital",
                about: "Just as the earth <span>is the foundation of all life,</span> Terra EA creates a reliable base <span>for automated trading with stable results.</span><br/><br/>The algorithm is designed for those <span>who value confidence.</span><br/><br/>The strategy has a <span>positive mathematical expectation</span> and has been proven by time and the market.",
                videoFallback: "Your browser does not support the video tag."
            },

            advantages: {
                titleAccent: "An intelligent approach",
                title: "to trading",
                items: [
                    {
                        title: "Combination of Indicators",
                        desc: "The algorithm is based on the synergy of RSI, Bollinger Bands, and ATR."
                    },
                    {
                        title: "Smart Risk Management",
                        desc: "Sophisticated capital management, hedging, and martingale used only when necessary."
                    },
                    {
                        title: "Money Management",
                        desc: "Terra demonstrates effective performance with minimal drawdowns on deposits from $1,000, which is rare for martingale bots."
                    }
                ]
            },
            results: {
                title: "Results speak for themselves",
                subtitle: "23 out of 24 trading months closed in profit.",
                stats: [
                    {label: "Year profit", value: "+25%"},
                    {label: "Max drawdown", value: "16.5%"},
                    {label: "Winrate", value: "72.3%"}
                ],
                button: "View statistics"
            },

            video: {
                titleAccent: "Video demonstration",
                title: "of the bot in action"
            },

            reviews: {
                titleAccent: "What those who use",
                title: "TERRA EA are saying"
            },
            reviews1: {
                more: "More reviews"
            },

            tests: {
                title: "Test results",
                titleAccent: "over the last 10 years",

                period: "Testing period",
                timeframe: "Timeframe",
                timeframeValue: "1 hour (H1)",
                dates: "Testing dates",

                depositProfit: "Deposit and profit",
                startDeposit: "Initial deposit",
                netProfit: "Net profit",

                pairs: "Currency pairs",

                risk: "Risk",
                maxDrawdown: "Maximum drawdown",

                trades: "Trade statistics"
            },

            buy: {
                desc: "A reliable foundation for automated trading with stable results.",
                price: "Price",
                buy: "Buy",
                parts: "Pay in installments"
            },

            stats: {
                yearProfit: "Year profit",
                maxDrawdown: "Max drawdown",
                winrate: "Winrate"
            },

            footer: {
                instagram: "Instagram",
                telegram: "Telegram",
                youtube: "YouTube"
            },
            reviewsList: [
                {
                    name: "Paul",
                    text: "I've been using the bot since November and am very satisfied with the result. I was looking for a passive income tool with low risks — this option was perfect. In two months, I got 4% net profit thanks to the compound interest system. The bot is fully automatic: I set it up with the seller's help and haven't interfered since. I'm especially pleased that the system turns itself off during major news events, minimizing risks. I expect about 40% annually. I recommend it as a reliable and safe tool.",
                },
                {
                    name: "John",
                    text: "The bot demonstrates excellent performance. I use it at minimum risks for stable capital growth. For me, it has become a great alternative to other ways of diversifying funds for interest. A huge plus is that the bot integrates with the Bybit exchange, and I can keep the entire deposit in my own account, which adds confidence in asset safety. The tool is convenient, clear, and most importantly, brings predictable profit without unnecessary hassle or daily monitoring.",
                },
                {
                    name: "Tom",
                    text: "I've been using the 'Terra' bot for three months now. I decided to test the strategy on high risks and the result was amazing — I have +48% on my deposit. It's really cool that the developer constantly updates the settings and is always in touch in the chat to answer questions. Besides the technical part, I'm impressed by the author's honesty: the words in the posts always match the real numbers. This builds great trust. Looking forward to new releases and algorithms, as this product is definitely worth attention.",
                },
                {
                    name: "Max",
                    text: "I purchased this software about a month ago and can already draw my first conclusions. The setup process was quick, and the strategy logic is clear even without deep technical knowledge. The bot works very precisely, without technical failures or errors in order execution. This is exactly the product that matches the stated characteristics. So far, everything is going according to plan, results are stable, so I can safely recommend this bot to those who value quality execution and clear trading logic.",
                },
                {
                    name: "David",
                    text: "I've been working with the 'Terra' bot for five months now. I consciously went for an experiment and lowered the safety level (increased the risks), even though the developer warned about possible consequences. Despite this, I'm very satisfied with the result for this period — the bot withstood market movements and showed a good profit. The system works stably even with aggressive settings. Thanks to Vova for a high-quality product that allows for flexible strategy management and achieving desired profits over the long run.",
                },
            ],
            botInfoPopup: {
                botInfo: [
                    "Unlimited number of bot activations",
                    "Lifetime access to updates",
                    "2 versions for MT4/MT5",
                    "Video instructions with step-by-step setup",
                    "Set-files for various risk levels",
                    "Access to a private news channel",
                    "100% guarantee that your results will match ours"
                ],
                botName: "TERRA EA",
                botPrice: 1000
            },
            calculator: {
                titleAccent: "Calculate your",
                title: "long-term profitability",
                themes: {
                    sumAndTerm: "Amount and Term",
                    interest: "Interest Calculation",
                    refill: "Top-up"
                },
                labels: {
                    startSum: "Initial amount",
                    unit: "Unit",
                    term: "Term",
                    frequency: "Frequency",
                    rate: "Interest rate",
                    sum: "Amount"
                },
                units: {
                    year: "Year",
                    month: "Month",
                    yearly: "Yearly",
                    monthly: "Monthly"
                },
                warnings: {
                    startSum: "The amount with which the investment begins",
                    term: "Number of years/months you plan to invest funds",
                    rate: "Size of annual/monthly income in percent",
                    refill: "The amount you plan to add to the deposit"
                },
                button: "Calculate Profitability",
                table: {
                    tableName: "Calculation Table",
                    balance: "Balance",
                    addedYear: "Added (year)",
                    addedMonth: "Added (month)",
                    totalAdded: "Total Investments",
                    incomeYear: "Annual Income",
                    incomeMonth: "Monthly Income",
                    totalIncome: "Total Income",
                    finalBalance: "Final Balance",
                    description: "Terra EA averages a stable +25% per year / 2.1% per month.<br/>The longer the investment period, the greater the magic of compound interest!",
                    descriptionAero: "Aero EA averages a stable +30% per year / 2.5% per month.<br/>The longer the investment period, the greater the magic of compound interest!",
                    descriptionHydro: "Hydro EA averages a stable +50% per year / 4.2% per month.<br/>The longer the investment period, the greater the magic of compound interest!"
                }
            }
        },

        aero: {
            reviewsList: [
                {
                    name: "William",
                    text: "I am writing this review based on the results of the first week of trading. It’s great to see that all trades perfectly match the Myfxbook monitoring; the profit is absolutely consistent. A great start, so I’m looking forward to a long and productive cooperation.",
                },
                {
                    name: "Lucas",
                    text: "In the first month of using the bot, I got this result ⬆️ +5% net profit on the deposit. It works stably, without unnecessary risk, with clear entry and exit logic. For me, this is a good and predictable result.",
                },
                {
                    name: "Benjamin",
                    text: "Hi! I've been using the Aero bot for exactly two months now. During this time, it has traded +$321 on my personal Bybit exchange deposit. I am completely satisfied with the result; the bot is performing excellently over the long run.",
                },
                {
                    name: "Oliver",
                    text: "I'm sharing a review of my experience using the bots. I bought two algorithms at once—I really liked the delivery and presentation. I launched them on one account and got great numbers. Support, consultations, and guidance are all at a high level.",
                },
                {
                    name: "Liam",
                    text: "Hi everyone. Two months have passed since I bought the Aero bot. On my personal Bybit account, the net profit is already +$321. The system works stably and fully justifies the investment.",
                },
            ],
            botInfoPopup: {
                botInfo: [
                    "Unlimited number of bot activations",
                    "Lifetime access to updates",
                    "2 versions for MT4/MT5",
                    "Video instructions with step-by-step setup",
                    "Set-files for various risk levels",
                    "Access to a private news channel",
                    "100% guarantee that your results will match ours",
                    "Bot configuration for prop firms"
                ],
                botName: "AERO EA",
                botPrice: 1200
            },
            hero: {
                botName: "Aero EA",
                theme: "Trading bot with the lowest drawdowns",
                desc: "Over 11 months of verified statistics and 10 years of tests with stable results.",
                buy: "Purchase bot",
                slogan: "The security of your capital",
                about: "Aero is the element of air; it can be as calm <span>as a light breeze or as dynamic as a storm,</span> turning wind into a gale thanks to adjustable risk levels.<br/><br/>At its core is a pattern recognition algorithm — kNN (k-Nearest Neighbors), <span>a machine learning method trained on 25+ years of Gold price data.</span><br/><br/>The result: <span>short, clean trades with a consistently high winrate and clearly defined risk on every position.</span>",
                videoFallback: "Your browser does not support the video tag."
            },
            seo: {
                title: "Aero EA — Safe Trading Bot with 3.7% Max Drawdown",
                description: "Aero EA: AI-based algorithm for XAUUSD (Gold). No martingale or grids. Perfect for prop firm challenges. 86.8% win rate and stable profit.",
                keywords: "Aero EA, prop firm bot, safe trading bot, XAUUSD gold robot, no martingale trading, AI trading bots"
            },
            advantages: {
                title: "Advantages",
                items: [
                    {
                        title: "Suitable for Prop Firms",
                        desc: "Since it does not use forbidden strategies, Aero is suitable for most popular prop firms."
                    },
                    {
                        title: "Market Adaptation",
                        desc: "The algorithm trades on the breakout of key price levels and adapts to various market stages."
                    },
                    {
                        title: "Flexibility for Any Style",
                        desc: "Ideal for both conservative and aggressive traders. You control the trading style yourself."
                    },
                    {
                        title: "Full Automation",
                        desc: "Aero EA works in the background, is fully automated, and does not require constant manual intervention."
                    }
                ]
            },
            results: {
                subtitle: "On a live account, Aero demonstrates phenomenal results with a profitability of 2%/month at a drawdown of 3.7%",
                winrateText: "Meanwhile, its win rate has reached 86.8%.",
                stats: [
                    {label: "Year profit", value: "+30%"},
                    {label: "Max drawdown", value: "3.7%"},
                    {label: "Winrate", value: "86.8%"}
                ],
                button: "View statistics"
            },
            video: {
                title: "<span>Video demonstration</span><br/> of the bot in action"
            },
            propInfo: {
                title: "Find out how to increase Aero profitability with prop firms",
                button: "Read more"
            },
            reviews: {
                titleAccent: "What those who use",
                title: "AERO EA are saying"
            },
            tests: {
                winTrades: "Profitable trades"
            },
            buy: {
                desc: "A reliable foundation for automated trading with stable results.",
            }
        },

        hydro: {
            reviewsList: [
                {
                    name: "Noah",
                    text: "I bought the bot two weeks ago; I was interested in the detailed statistics 📈 I tested it for a week since I've been in this field for a long time and know that often it's one thing in words and quite another in practice. I can confirm — everything matches the claims, and the trades align with the statistics.",
                },
                {
                    name: "Mateo",
                    text: "The bot successfully passed the first phase on FTMO in 22 trading days ✅ It closed the second verification phase in just 4 days. I am completely satisfied with the result; it works stably, without surprises, follows risk management, and shows a predictable outcome.",
                },
                {
                    name: "Kai",
                    text: "I made my first withdrawal from trading in a long time. Honestly, it's a very pleasant feeling, especially when the result is achieved without constant monitoring. A great bonus and a gift for the upcoming holidays that really motivates me to keep moving forward.",
                },
                {
                    name: "Maverick",
                    text: "I have a result of +$1200 on my personal Bybit account! The bot has been trading for 3 months, and I plan to increase the deposit in the near future.",
                },
                {
                    name: "Hudson",
                    text: "Hi again, I want to write a review about the bot's performance and, actually, about your work. Initially, the bot was bought for a prop firm; I'll say right away that I was warned that I take all risks with prop firms upon myself. As for the personal deposit, the bot, with all its ups and downs, brought 4-5% for the period since August 18.",
                },
                {
                    name: "Theodore",
                    text: "I managed to get 25% in a month, taking into account the stops on both low-risk and high-risk settings! 😂",
                },
            ],
            botInfoPopup: {
                botInfo: [
                    "Unlimited number of bot activations",
                    "Lifetime access to updates",
                    "2 versions for MT4/MT5",
                    "Video instructions with step-by-step setup",
                    "Set-files for various risk levels",
                    "Access to a private news channel",
                    "100% guarantee that your results will match ours",
                    "Bot configuration for prop firms"
                ],
                botName: "HYDRO EA",
                botPrice: 2000
            },
            hero: {
                botName: "Hydro EA",
                theme: "Trading bot with the highest profitability",
                desc: "Over 7 months of verified statistics and 10 years of tests with stable results.",
                buy: "Purchase bot",
                slogan: "Growth of your capital",
                about: "Hydro combines the calmness of deep waters and the strength of the tides, <span>helping to find a balance between stability and profitability.</span><br/><br/>It reacts quickly to market changes, <span>finding optimal entry and exit points</span> with high precision.<br/><br/>With a win rate above 90% and profitability of over 4.5% per month, <span>Hydro proves to be a perfect scalping bot that mimics human trading behavior as closely as possible.</span>",
                videoFallback: "Your browser does not support the video tag."
            },
            seo: {
                title: "Hydro EA — Trading Bot with 91.9% Win Rate and High Profitability",
                description: "Hydro EA: Professional scalping bot for Gold (XAUUSD). Average monthly return of 5%, volatility protection, and no-martingale execution. The best choice for capital management.",
                keywords: "Hydro EA, scalping bot, high-profit trading robot, gold bot, 90 win rate trading, XAUUSD automation, professional trading algorithms"
            },
            advantages: {
                title: "Advantages",
                items: [
                    {
                        title: "Intelligent Precision",
                        desc: "High win rate thanks to intelligent analysis"
                    },
                    {
                        title: "Risk Control",
                        desc: "Trades with stop-losses without martingale or averaging"
                    },
                    {
                        title: "Volatility Protection",
                        desc: "Features a news filter to exclude trading during volatile periods"
                    },
                    {
                        title: "Prop Compatibility",
                        desc: "Due to the absence of martingale and grid, the algorithm fully complies with the strict risk management rules of most prop firms."
                    },
                    {
                        title: "24/7 Monitoring",
                        desc: "The algorithm works 24/7 without emotion or fatigue, instantly reacting to trading signals in any session."
                    }
                ]
            },
            results: {
                subtitle: "On a public account, Hydro demonstrates phenomenal results with an average profitability of 5% per month.",
                winrateText: "Meanwhile, its win rate has reached 91.9%.",
                stats: [
                    {label: "Year profit", value: "+50%"},
                    {label: "Max drawdown", value: "14.3%"},
                    {label: "Winrate", value: "91.9%"}
                ]
            },
            propInfo: {
                title: "Find out how to increase Hydro profitability with prop firms"
            },
            reviews: {
                titleAccent: "What those who use",
                title: "HYDRO EA are saying"
            },
            tests: {
                timeframeValue: "1 day ( D1 )"
            }
        },

        home: {
            bestOfferProp: "Best For Prop-Companies",
            piecePay: "Available payment in installments",
            trailer:"Trailer",
            mainVideoText:"See What We're Building",
            mainVideoDesc:"Our official teaser — the philosophy, the elements, and the standard behind every system we release.",
            mainVideoButton:"Explore Algo",
            botsList: [
                {
                    name: "Terra EA",
                    description: "The bot with the longest public statistics in Ukraine.",
                    advantages: {yearProfit: "+25%", maxDrawDown: "16.5%", winRate: "72.3%"},
                    price: 1000,
                    href: "/terra",
                    prop: false,
                    paying: true,
                },
                {
                    name: "Aero EA",
                    description: "The bot with the lowest drawdown in the lineup.",
                    advantages: {yearProfit: "+30%", maxDrawDown: "3.7%", winRate: "86.8%"},
                    price: 1200,
                    href: "/aero",
                    prop: true,
                    paying: true,
                },
                {
                    name: "Hydro EA",
                    description: "The bot with the highest profitability in the lineup.",
                    advantages: {yearProfit: "+50%", maxDrawDown: "14.3%", winRate: "91.9%"},
                    price: 2000,
                    href: "/hydro",
                    prop: true,
                    paying: true
                }
            ],
            reviewsList: [
                {
                    name: "Michael",
                    text: "I bought the bot two weeks ago; I was interested in the detailed statistics 📈 I tested it for a week since I've been in this field for a long time and know that words often diverge from practice. I confirm — everything matches the claims, and the trades align with the statistics."
                },
                {
                    name: "Robert",
                    text: "The bot successfully passed the first phase on FTMO in 22 trading days ✅ It closed the second verification phase in just 4 days. I am completely satisfied with the result; it works stably, without surprises, and follows risk management."
                },
                {
                    name: "John",
                    text: "I made my first withdrawal from trading in a long time. Honestly, it's a very pleasant feeling, especially when the result is achieved without constant monitoring. A great bonus and a gift for the holidays."
                },
                {
                    name: "Joseph",
                    text: "I'm writing a review about my experience using the bots. I bought two algorithms at once — I really liked the presentation. I launched them on one account and got great numbers. Support and consultations are at a high level."
                },
                {
                    name: "Richard",
                    text: "In the first month of using the bot, I received +5% net profit on the deposit. It works stably, without unnecessary risk, with clear entry and exit logic. For me, this is a good, predictable result."
                },
                {
                    name: "Christopher",
                    text: "I haven't had the time to leave feedback for Terra for a while. In 3 months on high-risk settings, I got +48%. Very happy with the bot, updates, and support. Special respect for the honesty — the numbers match reality."
                }
            ],
            faq: [
                {
                    question: "How do I choose a bot?",
                    answer: "All risks for each bot are detailed on its page. We work exclusively with stable risk settings that do not exceed a 15-20% drawdown of the deposit."
                },
                {
                    question: "Do I need to keep my computer on all the time?",
                    answer: "No. The bots work on remote servers. You can turn off your phone or laptop — the process will not be interrupted."
                },
                {
                    question: "Do I need extensive trading experience?",
                    answer: "Absolutely not. All you need to do is create an account and connect the bot. Video instructions will be available immediately after purchase."
                },
                {
                    question: "Can I lose my entire deposit?",
                    answer: "Our bots have been tested at various market stages and in critical situations. With our settings, losing the entire deposit is impossible."
                },
                {
                    question: "How can I get a consultation?",
                    answer: "For the correct selection, we recommend familiarizing yourself with each bot or contacting us for a consultation via Telegram, where we will help determine the right algorithm for you."
                }
            ], hero: {
                title: "Your capital grows — without your involvement",
                desc: "Trading bots that operate autonomously using a clear strategy — with minimal drawdown and a real track record on live accounts.",
                button: "Select a Bot"
            }, stats: {
                title: "<span>Our team has already automated trading</span><br/>for many clients, we will help you too",
                management: "under management",
                items: [
                    {num: "2", desc: "Years on the market"},
                    {num: "4", desc: "Profitable bots"},
                    {num: "5", desc: "Accounts with live statistics"},
                    {num: "+80%", desc: "For 2025"}
                ]
            },
            steps: {
                title: "<span>The journey from setup</span> to the first trade",
                items: [
                    {
                        title: "Algorithm Selection",
                        desc: "You define your goals and acceptable risk. Our catalog contains solutions for both conservative accumulation and active trading."
                    },
                    {
                        title: "Connection",
                        desc: "The bot is installed on your account in a couple of clicks. You receive all instructions and a license for activation."
                    },
                    {
                        title: "Autonomous Trading",
                        desc: "The algorithm scans the market 24/7. As soon as the strategy conditions are met, the bot instantly opens a position."
                    },
                    {
                        title: "Monitoring and Results",
                        desc: "You follow the statistics in real-time. At any moment, the bot's operation can be paused or modified."
                    }
                ]
            }, effective: {
                title: "Why choose <br/><span>algorithmic trading?</span>",
                items: [
                    {
                        title: "Trading without the 'human factor'",
                        desc: "The bot won't close a trade too early due to fear or stay in a loss due to hope. Only mathematical expectation."
                    },
                    {
                        title: "Real Statistics",
                        desc: "Each algorithm has public statistics for at least 6 months of operation on a real account with a licensed broker."
                    },
                    {
                        title: "Passive Income",
                        desc: "The market never sleeps. The bot works day and night while you rest. It is a full-fledged passive income without your involvement."
                    },
                    {
                        title: "Transparency and Testing",
                        desc: "Every algorithm is run through historical data. You understand the logic of the system's operation before you even launch it."
                    }
                ]
            },
            catalog: {
                title: "Bot Catalog",
                propLabel: "Suitable for Prop",
                payingLabel: "Installments",
                moreDetails: "More details"
            },
            reviews: {
                titleAccent: "What those say who",
                title: "have already switched to ALGO"
            },
            faqTitle: "Frequently Asked Questions",
            consult: {
                title: "Difficult to choose your first bot?",
                desc: "The market offers hundreds of options, but not all of them fit your capital and temperament. We will help you find a solution that is comfortable exactly for you.",
                button: "Get a consultation"
            }, header: {
                howItWorks: "How it works",
                advantages: "Advantages",
                catalog: "Bot Catalog",
                reviews: "Reviews",
                faq: "FAQ",
                selectBot: "Select Bot"
            },
        }, popup: {
            subtitle: "Forex trading bot",
            title: "Convenient way to connect",
            labels: {
                name: "Your name",
                contact: "Your"
            },
            placeholders: {
                name: "Your name"
            },
            channels: {
                tg: "telegram",
                inst: "instagram"
            },
            submit: "Send",
            or: "Or write to us",
            writeTg: "Message on Telegram",
            error: "An error occurred while sending the request."
        }, thx: {
            title: "Thank you! Your request has been successfully sent.",
            desc: "Our manager will process the information and contact you shortly to clarify the details. Have a great day!",
            button: "Back to Home"
        }
    },


};
